<template>
  <div>

    <div class="layer-header">
      <h1 class="header-title">개인정보 수집 &#183; 이용 동의</h1>
    </div>

    <div class="layer-content shipping toss">
      <h2 class="busTxt">
        <!-- 20220216 문구변경 -->
        (선택) A Pay 이벤트 참여 – 개인정보 수집 이용동의
      </h2>
      <div class="layer-sum">
        한국암웨이㈜는 A Pay 자동이체 이벤트 참여를 위하여 다음과 같이 귀하의 개인정보를 수집, 이용합니다.
      </div>

      <dl class="personal_comm">
        <dt>
          ○ 수집하는 개인정보의 항목:
        </dt>
        <dd>
          - 회원번호, 이름, 전화번호, 주소
        </dd>
      </dl>

      <dl class="personal_comm">
        <dt>
          ○ 개인정보의 수집 및 이용 목적:
        </dt>
        <dd>
          - A Pay 자동이체 이벤트 참여자의 경품 추첨, 당첨자 게시 및 개별 안내
        </dd>
      </dl>

      <!-- 20220216 period class 추가 -->
      <dl class="personal_comm period">
        <dt>
          ○ 개인정보의 보유 및 이용기간:
        </dt>
        <dd>
          이벤트 종료 후 1개월 동안 보유
        </dd>
      </dl>

      <p class="person_txt01">
        *단 사진 및 영상의 경우, 이미 게재된 경우를 제외합니다.
      </p>
      <br>
      <div class="layer-sum">
        ※ 귀하는 위 동의를 거부할 권리가 있으나, 이에 동의하지 않는 경우 이벤트 참여가 불가합니다.
      </div>
      <br>
      <div class="layer-sum">
        본인은 위 개인정보 수집 ∙ 이용에 동의합니다.
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ApayAgreement"
}
</script>

<style scoped>

</style>
